import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, timeout: 25000 });

// Force the Portuguese-from-Portugal informal style ("3.408,23 €") even when the
// browser ICU emits a NBSP as the thousands separator. Requirement from the
// dossier prompt (section 5): moeda em pt-PT com ponto e vírgula decimal.
const normalizePt = (formatted) =>
  formatted.replace(/\u00a0|\u202f|\s/g, '.').replace(/\.€/, ' €');

export const eur = (n, digits = 0) => {
  const raw = new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(Number.isFinite(n) ? n : 0);
  return normalizePt(raw);
};

export const eur2 = (n) => eur(n, 2);

export const num = (n, digits = 0) => {
  const raw = new Intl.NumberFormat('pt-PT', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(Number.isFinite(n) ? n : 0);
  return normalizePt(raw);
};

export const pct = (n, digits = 1) => {
  if (!Number.isFinite(n)) return '—';
  const raw = new Intl.NumberFormat('pt-PT', {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(n);
  return `${normalizePt(raw)} %`;
};

export const monthsToLabel = (months) => {
  if (months === null || months === undefined) return 'Não recuperado no horizonte';
  const decimals = Math.round(months * 10) / 10;
  const recoveryMonth = Math.max(1, Math.ceil(months));
  // Distinguish the interpolated duration from the month of recovery:
  // 6,35 meses = recuperação DURANTE o mês 7 (e não até ao fim do mês 6).
  return `${num(decimals, 1)} meses · recuperação no mês ${recoveryMonth}`;
};

// Compact variant for tight spaces (scenario cards): one decimal + recovery
// month, using the SAME formula/base as monthsToLabel so every surface agrees.
export const monthsToShort = (months) => {
  if (months === null || months === undefined || !Number.isFinite(months)) return '—';
  const decimals = Math.round(months * 10) / 10;
  const recoveryMonth = Math.max(1, Math.ceil(months));
  return `${num(decimals, 1)} m · mês ${recoveryMonth}`;
};


export const DISCLAIMER =
  'Projeções baseadas nas hipóteses indicadas; não constituem garantia de resultados. Valores sem IVA e sujeitos a validação contabilística, fiscal, comercial e operacional.';

export const PASSWORD_STORAGE_KEY = 'lio-dossier-password';
